/**
 * Cleans audiotrack id or label text by removing parentheses but keeping their contents
 * This helps with consistent comparison of audio track IDs and labels
 */
export const cleanAudioTrackText = (text: string | undefined): string => {
  if (!text) return '';

  // Remove only the parentheses characters but keep their content
  return text
    .replace(/\(/g, '') // Remove opening parenthesis (
    .replace(/\)/g, '') // Remove closing parenthesis )
    .replace(/\[/g, '') // Remove opening bracket [
    .replace(/\]/g, '') // Remove closing bracket ]
    .replace(/\{/g, '') // Remove opening brace {
    .replace(/\}/g, '') // Remove closing brace }
    .replace(/</g, '') // Remove opening angle bracket <
    .replace(/>/g, '') // Remove closing angle bracket >
    .replace(/\s+/g, ' ') // Replace multiple spaces with a single space
    .trim(); // Remove leading and trailing spaces
};

export default cleanAudioTrackText;
